import type { Static } from 'runtypes';
import { Literal, Record, String } from 'runtypes';
import { CoreEventRuntype } from './core';
import { type BaseEvent, BaseEventRuntype } from './base';
import { BaseAiChatEventRuntype } from './ai-chat';
import { ClickstreamEventEnum } from 'bc-model';

const AiChatRetryEventBrowserRuntype = BaseEventRuntype.And(BaseAiChatEventRuntype).And(
  Record({
    event: Literal(ClickstreamEventEnum.AI_ASSIST_RETRY),
    version: Literal(1),
  })
);

const AiChatRetryEventServerRuntype = AiChatRetryEventBrowserRuntype.And(CoreEventRuntype).And(
  Record({
    sessionId: String,
  })
);

type AiChatRetryBrowserEvent = Static<typeof AiChatRetryEventBrowserRuntype>;
type AiChatRetryServerEvent = Static<typeof AiChatRetryEventServerRuntype>;

const isAiChatRetryBrowserEvent = (obj: BaseEvent): obj is AiChatRetryBrowserEvent => {
  return obj.event === 'AI Assist Retry';
};

const isAiChatRetryServerEvent = (obj: BaseEvent): obj is AiChatRetryServerEvent => {
  return obj.event === 'AI Assist Retry';
};

export {
  isAiChatRetryBrowserEvent,
  isAiChatRetryServerEvent,
  AiChatRetryEventBrowserRuntype,
  AiChatRetryEventServerRuntype,
  type AiChatRetryBrowserEvent,
  type AiChatRetryServerEvent,
};
